import ThirdComponent from './ThirdComponent';

export default ThirdComponent;
